export default {
  // getItem: state => (menuId) => state.menus.find((menu) => menu.id == menuId),
}
